import {UI} from "../../../../../stem-core/ui/UIBase";

import {Messages} from "../../../../Messages.js";
import {Payment} from "../../../../State.js";
import {SubscriptionPayments} from "../../subscriptions/sections/SubscriptionPayments.jsx";
import {Dispatcher} from "../../../../../stem-core/base/Dispatcher";
import {PaymentDescription} from "../../../../common/PaymentDescription.jsx";
import {Link} from "../../../../../stem-core/ui/UIPrimitives.jsx";
import {EndpointPaginator} from "../../../../../stem-core/state/pagination/EndpointPaginator";
import {UIPaginationManager} from "../../../../ui/BaseCard.jsx";


export class DonationPayments extends SubscriptionPayments {
    paginator = new EndpointPaginator(
        Payment,
        Payment.API_LIST_ENDPOINT,
        {resourceTypes: [Payment.ResourceType.DONATION]},
        {resourceType: Payment.ResourceType.DONATION},
    );
    paginationHandler = new UIPaginationManager(this);

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.donationPayments,
            description: () => (this.getPayments().length || !this.paginator.lastPageLoaded) ? "" : Messages.emptyDonationPayments,
        };
    }

    getPaymentDescription(payment) {
        const donation = payment.getResource();
        return {
            title: `${donation.getMerchantTitle()}${donation.isRecurring() ? (" (" + Messages.recurring.toString().toLowerCase() + ")") : ""}`,
            highlighted: donation.isRecurring(),
        };
    }

    getDescriptionColumnValue(payment) {
        const {styleSheet} = this;
        const {title, highlighted} = this.getPaymentDescription(payment);
        return <PaymentDescription payment={payment}>
            {highlighted ? <Link
                    className={styleSheet.paymentTitle}
                    style={{color: styleSheet.themeProps.LINK_COLOR}}
                    onClick={() => Dispatcher.Global.dispatch("highlightEntry", payment.getResource())}
                >
                    {title}
                </Link>
                : <div className={styleSheet.paymentTitle}>{title}</div>
            }
        </PaymentDescription>;
    }

    onMount() {
        super.onMount();
        this.paginationHandler.attach();
    }
}
